// extracted by mini-css-extract-plugin
module.exports = {"spacer":"bp_dJ"};